import { render, staticRenderFns } from "./EmployeePerformance.vue?vue&type=template&id=4c8395bc&"
import script from "./EmployeePerformance.vue?vue&type=script&lang=js&"
export * from "./EmployeePerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports